import { render, staticRenderFns } from "./Anonymisation.vue?vue&type=template&id=dccd0bbc&"
import script from "./Anonymisation.vue?vue&type=script&lang=ts&"
export * from "./Anonymisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports